/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ActiveStep from './ActiveStep/index'
import CancelAction from './CancelAction/index'
import NextAction from './NextAction/index'
import React from 'react'
import SkipAction from './SkipAction/index'
import Step from './Step/index'
import SubmitAction from './SubmitAction/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2LocationPin from 'DesignSystem/Svgs/Tysiav2LocationPin/index'
import Tysiav2Warning from 'DesignSystem/Svgs/Tysiav2Warning/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let globalCurrentLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.name',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let stepsStepsValueData = fromData.useDataValue({ viewPath,
context: 'steps',
path: 'steps',
})
let selectedIndexValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'index',
})
let constantData = 1
let aggregateData = fromAggregate.add(selectedIndexValueData, constantData)
let selectedLabelValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'label',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let selectedDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'description',
})
  return (<React.Fragment
>
<TysiaModalContent
  viewPath={`${viewPath}/TysiaModalContent`}
 paddingBottom={0}
 paddingLeft={0}
 paddingRight={0}
 paddingTop={0}
 overflowY="hidden"
>
{childProps => (
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pl-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-4-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-5-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2LocationPin
  viewPath={`${viewPath}/Tysiav2LocationPin`}
 marginRight={dtSpaceXxs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="bold"
 textTransform="uppercase"
 marginTop={dtSpaceXxxs}
 color={dtColorsNeutral400}
 data="global.current_location.name"
 text={globalCurrentLocationNameValueData}
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 backgroundColor={dtColorsNeutral200}
 marginTop={0}
 marginBottom={dtSpaceXs}
/>
<div
  data-testid="Content.List"
  data-view-path={viewPath}
 style={{'--pb-5-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(stepsStepsValueData) && stepsStepsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="step"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Step(${item?.id ?? item?._id ?? index})`}
      >
<Step
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Step(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-5-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral200,'--btlr-6-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-7-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-8-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-9-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="selected.index"
 data={1}
 size="extralarge"
 weight="semibold"
 aggregate="/Data/aggregate.js add"
 text={aggregateData}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="selected.label"
 size="large"
 weight="medium"
 marginTop={dtSpaceLs}
 text={selectedLabelValueData}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 backgroundColor={dtColorsNeutral200}
 marginTop={dtSpaceS}
 marginBottom={dtSpaceM}
/>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 style={{'--mb-10-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-11-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal3}`}
>
<Tysiav2Warning
  viewPath={`${viewPath}/Tysiav2Warning`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral400}
 weight="bold"
 size="tiny"
 text="IMPORTANT - READ CAREFULLY BEFORE PROCEEDING"
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="selected.description"
 text={selectedDescriptionValueData}
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 className="views-block"
>
<ActiveStep
  viewPath={`${viewPath}/ActiveStep`}
/>
</div>
<SkipAction
  viewPath={`${viewPath}/SkipAction`}
/>
</div>
</div>
</div>
)}
</TysiaModalContent>
<TysiaModalFooter
  viewPath={`${viewPath}/TysiaModalFooter`}
 gap={dtSpaceS}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<NextAction
{...childProps}
  viewPath={`${viewPath}/NextAction`}
/>
<SubmitAction
{...childProps}
  viewPath={`${viewPath}/SubmitAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }